import {
  createEmptyOpeningHours,
  normalizeOpeningHours,
  serializeOpeningHours,
} from '../constants/openingHours';
import { asArrayText, parseList } from './formatters';
export const emptyPlaceForm = {
  googlePlaceId: '',
  isVerified: false,
  status: 'pending',
  behaviorType: '',
  source: 'system',
  name: {
    he: '',
    en: '',
  },
  shortName: {
    he: '',
    en: '',
  },
  branchName: {
    he: '',
    en: '',
  },
  city: {
    he: '',
    en: '',
  },
  country: {
    he: '',
    en: '',
  },
  address: {
    he: '',
    en: '',
  },
  categoriesText: '',
  lng: '',
  lat: '',
  openingHours: createEmptyOpeningHours(),
};
export const toPlaceForm = (place) => {
  return {
    ...emptyPlaceForm,
    googlePlaceId: place.googlePlaceId || '',
    isVerified: Boolean(place.isVerified),
    status: place.status || 'pending',
    behaviorType: place.behaviorType || '',
    source: place.source || 'system',
    name: {
      he: place.name?.he || '',
      en: place.name?.en || '',
    },
    shortName: {
      he: place.shortName?.he || '',
      en: place.shortName?.en || '',
    },
    branchName: {
      he: place.branchName?.he || '',
      en: place.branchName?.en || '',
    },
    city: {
      he: place.city?.he || '',
      en: place.city?.en || '',
    },
    country: {
      he: place.country?.he || '',
      en: place.country?.en || '',
    },
    address: {
      he: place.address?.he || '',
      en: place.address?.en || '',
    },
    categoriesText: asArrayText(place.categories),
    lng: place.location?.coordinates?.[0] ?? '',
    lat: place.location?.coordinates?.[1] ?? '',
    openingHours: normalizeOpeningHours(place.openingHours || []),
  };
};
export const toPlacePayload = (placeForm) => {
  const lng = placeForm.lng === '' ? null : Number(placeForm.lng);
  const lat = placeForm.lat === '' ? null : Number(placeForm.lat);
  return {
    googlePlaceId: placeForm.googlePlaceId || undefined,
    isVerified: placeForm.isVerified,
    status: placeForm.status,
    behaviorType: placeForm.behaviorType || undefined,
    source: placeForm.source,
    name: placeForm.name,
    shortName: placeForm.shortName,
    branchName: placeForm.branchName,
    city: placeForm.city,
    country: placeForm.country,
    address: placeForm.address,
    categories: parseList(placeForm.categoriesText),
    openingHours: serializeOpeningHours(placeForm.openingHours),
    location:
      lng === null || lat === null
        ? {
            coordinates: [],
          }
        : {
            type: 'Point',
            coordinates: [lng, lat],
          },
  };
};
